
<template>
    <input-text
      v-model="cmpValue"
      v-bind="$attrs"
      format="numeric"
      type="tel"
      pattern="[0-9]*"
      :prefix="options.prefix"
      :suffix="options.suffix"
      v-on="listeners"
    ><template v-for="(_, slotName) in $scopedSlots" v-slot:[slotName]="context">
      <slot :name="slotName" v-bind="context" />
    </template>
    <template v-for="(_, name) in $slots" v-slot:[name]>
      <slot :name="name" />
    </template></input-text>
</template>

<script>
export default {
  props: {
    value: { type: [String, Number], default: '' },
    valueWhenIsEmpty: { type: String, default: '' },
    valueOptions: { type: Object, default: function () { return { min: 0, minEvent: 'SetValueMin' } } },
    // Other v-text-field properties
    properties: { type: Object, default: function () { return {} } }
  },
  data: function () {
    return { listeners: {}, attrs: {}, oldVal: this.value }
  },
  watch: {
    value (val, oldVal) {
      if (!oldVal && val && oldVal !== val) {
        this.formatNewValue(val)
      }
    }
  },
  /*
   v-model="cmpValue": Dessa forma, ao digitar, o valor é atualizado automaticamente no componente pai.
   O valor digitado entra pelo newValue do Set e é emitido para o componente pai.
   the-vue-mask nao funciona corretamente ao incluir valores existentes no componente pai.
  */
  computed: {
    cmpValue: {
      get: function () {
        if ((this.$attrs.readonly === '' || this.$attrs.readonly === true) || (this.$attrs.disabled === '' || this.$attrs.disabled === true)) {
          return this.value
        }
        return this.value || this.value === 0 ? this.humanFormat(this.value.toString()) : this.valueWhenIsEmpty;
      },
      set: function (newValue) {
        this.formatNewValue(newValue)
      }
    },

    options () {
      const options = { locale: 'pt-BR', prefix: '', suffix: '', length: 15, precision: 2 }

      switch (this.$attrs.format) {
        case 'currency':
          options.prefix = 'R$ '
          break
        case 'decimal':
          break
        case 'percent':
          options.max = 100
          options.length = 3 + options.precision
          options.suffix = ' %'
          break
        default:
          options.precision = 0
          break
      }

      if (this.$attrs.length) {
        options.length = this.$attrs.length
      }

      if (this.$attrs.max || this.$attrs.max === 0) { options.max = this.$attrs.max }
      if (this.$attrs.min || this.$attrs.min === 0) { options.min = this.$attrs.min }

      if (this.$attrs.precision) {
        const max = options.max.toString().split('.')
        options.precision = parseInt(this.$attrs.precision)
        options.length = max[0].length + parseInt(this.$attrs.precision)
      }
      return options
    }
  },
  methods: {
    formatNewValue (newValue) {
      if (newValue === '0') {
        this.$emit('input', 0);
        return
      }
      newValue = this.machineFormat(newValue)

      if (newValue !== this.oldVal) {
        this.oldVal = newValue
        if (newValue || newValue === 0 || newValue === '0') {
          this.$emit('input', this.$api.UI.Parse.Decimal(newValue, this.options.precision));
        } else {
          this.$emit('input', null);
        }
      }
    },
    humanFormat: function (number) {
      if (isNaN(number)) {
        number = '';
      } else {
        // number = Number(number).toLocaleString(this.options.locale, {maximumFractionDigits: 2, minimumFractionDigits: 2, style: 'currency', currency: 'BRL'});
        number = Number(number).toLocaleString(this.options.locale, {
          maximumFractionDigits: this.options.precision,
          minimumFractionDigits: this.options.precision
        });
      }
      return number;
    },
    machineFormat (number) {
      if (number) {
        number = this.cleanNumber(number);
        // Ajustar quantidade de zeros à esquerda
        number = number.padStart(parseInt(this.options.precision) + 1, '0');
        // Incluir ponto na casa correta, conforme a precisão configurada
        number = number.substring(0, number.length - parseInt(this.options.precision)) +
          '.' +
          number.substring(number.length - parseInt(this.options.precision), number.length)
        if (isNaN(number)) {
          number = this.valueWhenIsEmpty
        }
      } else { number = this.valueWhenIsEmpty }

      if (this.options.precision === 0) { number = this.cleanNumber(number) }

      return number;
    },
    // Retira todos os caracteres não numéricos e zeros à esquerda
    cleanNumber: function (value) {
      let result = '';
      if (value) {
        let flag = false;
        let arrayValue = []
        if (typeof value === 'number') {
          arrayValue = value.toFixed(this.options.precision).split('');
        } else {
          arrayValue = value.toString().split('');
        }
        for (var i = 0; i < arrayValue.length; i++) {
          if (this.isInteger(arrayValue[i])) {
            if (!flag) {
              // Retirar zeros à esquerda
              if (arrayValue[i] !== '0') {
                result = result + arrayValue[i];
                flag = true;
              }
            } else {
              result = result + arrayValue[i];
            }
          }
        }
      }
      return result;
    },
    isInteger (value) {
      let result = false;
      if (Number.isInteger(parseInt(value))) {
        result = true;
      }
      return result;
    },
    targetLength (key) {
      if (Number(this.cleanNumber(this.value).length) >= Number(this.options.length)) {
        return true;
      } else {
        if (Number(this.machineFormat(this.cleanNumber(this.value) + key)) > this.$attrs.max) {
          return true;
        }
        return false;
      }
    },
    onBlur () {
      let val = this.value
      if (!val) { val = '' }
      if (val.length === 0 || parseFloat(val) <= this.valueOptions.min) { this.$emit(this.valueOptions.minEvent || 'SetValueMin', this.valueOptions.min) }
      if ((this.valueOptions.max || this.valueOptions.max === 0) && parseFloat(val) >= this.valueOptions.max) { this.$emit(this.valueOptions.maxEvent || 'SetValueMax', this.valueOptions.max) }
      if (this.$listeners.blur) { this.$emit('blur') }
    },
    keyPress ($event) {
      // console.log($event.keyCode); //keyCodes value
      const keyCode = $event.keyCode ? $event.keyCode : $event.which;
      // if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
      if (keyCode < 48 || keyCode > 57) {
        // 46 is dot
        $event.preventDefault();
      }
      if (this.targetLength($event.key)) {
        $event.preventDefault();
      }
      if (this.$listeners.keypress) { this.$emit('keypress', $event) }
    },
    onPaste (event) {
      let val = event.clipboardData.getData('text/plain').replace(/\D/g, '')
      let vlrAtual = event.target.value
      if (event.target.selectionStart < event.target.selectionEnd) { vlrAtual = vlrAtual.replace(event.target.value.substring(event.target.selectionStart, event.target.selectionEnd), '') }
      val = this.cleanNumber(vlrAtual.slice(0, event.target.selectionStart) + val + vlrAtual.slice(event.target.selectionStart))
      if (Number(this.cleanNumber(val).length) >= Number(this.options.length)) {
        const difference = Math.abs(Number(this.cleanNumber(val).length) - Number(this.options.length)) * -1
        val = this.cleanNumber(val).slice(0, difference)
      }
      this.formatNewValue(val)
      if (this.$listeners.paste) { this.$emit('paste', event) }
      event.preventDefault()
      event.stopPropagation()
    }
  },
  created () {
    this.listeners = { ...this.$listeners, keypress: this.keyPress, blur: this.onBlur, input: undefined, paste: this.onPaste }
    if ((this.options.min || this.options.min === 0) && !this.attrs.min) { this.$attrs.min = this.options.min }
    if ((this.options.max || this.options.max === 0) && !this.attrs.max) { this.$attrs.max = this.options.max }
  }
};
</script>
